import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


// 修改state中的webUrl值
// store.state.webUrl = 'https://www.yixi365.com'
// store.state.webUrl = 'http://localhost:8000'


import axios from 'axios';


const app = createApp(App)
app.use(router)
app.use(store)
// axios.defaults.baseURL = 'http://localhost:8000' //本地开发或调试时用
axios.defaults.baseURL = 'https://www.yixi365.com' //上传到服务器时用
axios.defaults.withCredentials = true;


// CSRF令牌拦截器：从sessionStorage会话中获取，不存在则请求并存储
axios.interceptors.request.use(config => {
  // 只对需要CSRF令牌的请求方法处理（post/put/delete）
  if (['post', 'put', 'delete'].includes(config.method)) {
    // 1. 先从sessionStorage读取已存储的令牌
    const storedCsrfToken = sessionStorage.getItem('csrfToken');
    if (storedCsrfToken) {
      // 2. 若存在令牌，直接添加到请求头
      config.headers['X-CSRFToken'] = storedCsrfToken;
      return Promise.resolve(config);
    } else {
      // 3. 若不存在令牌，调用接口获取并存储到sessionStorage
      return axios.get("/app01/get_csrf", { withCredentials: true })
        .then(res => {
          const newCsrfToken = res.data.csrfToken;
          // 存储令牌到sessionStorage会话中（退出页面自动清除）
          sessionStorage.setItem('csrfToken', newCsrfToken);
          // 添加到请求头
          config.headers['X-CSRFToken'] = newCsrfToken;
          return config;
        })
        .catch(error => {
          // 处理令牌获取失败的情况（如接口错误）
          console.error('获取CSRF令牌失败：', error);
          return Promise.reject(error);
        });
    }
  }
  return config;
});

// // CSRF令牌拦截器（旧版，每次请求都要获取一次）
// axios.interceptors.request.use(config => {
//   if (['post', 'put', 'delete'].includes(config.method)) {
//     return axios.get("/app01/get_csrf",{withCredentials: true}).then(res => {
//       config.headers['X-CSRFToken'] = res.data.csrfToken
//       return config
//     })
//   }
//   return config
// })

app.config.globalProperties.$axios = axios

app.mount('#app')
